var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-message"},[_c('i',{staticClass:"icon-no-message"}),_c('strong',[_vm._v(_vm._s(_vm.translate("chat", "Нет сообщений", {})))])])}
var staticRenderFns = []

export { render, staticRenderFns }